import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/img/close.png'
import _imports_1 from '@/assets/img/pocket.png'
import _imports_2 from '@/assets/img/open-return.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "flop-modal-cover" }, null, -1)
const _hoisted_2 = { class: "flop-modal-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "pockets" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "desc"
}
const _hoisted_7 = {
  key: 1,
  class: "desc"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      (_ctx.flopData.state == 1)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "close",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClick && _ctx.closeClick(...args)))
          }, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: "title",
        innerHTML: _ctx.flopData.state == 1 ? _ctx.openTitle : _ctx.flopData.amount ? _ctx.winTitle : _ctx.failTitle
      }, null, 8, ["innerHTML"]),
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            class: ["pocket-item btn", _ctx.flopData.state == 2 && index === _ctx.chooseIndex && 'choosed'],
            key: index,
            onClick: ($event: any) => (_ctx.chooseClick(index))
          }, [
            _hoisted_5,
            (_ctx.flopData.state == 2 && _ctx.chooseIndex === index && _ctx.flopData.amount)
              ? (_openBlock(), _createBlock("div", _hoisted_6, _toDisplayString(_ctx.flopData.amount) + " 元", 1))
              : _createCommentVNode("", true),
            (_ctx.flopData.state == 2 && _ctx.chooseIndex === index && !_ctx.flopData.amount)
              ? (_openBlock(), _createBlock("div", _hoisted_7, "兔年吉祥"))
              : _createCommentVNode("", true)
          ], 10, ["onClick"]))
        }), 128))
      ]),
      (_ctx.flopData.state == 2)
        ? (_openBlock(), _createBlock("img", {
            key: 1,
            class: "btn return-btn",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeClick && _ctx.closeClick(...args))),
            src: _imports_2
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}